import styled, { css } from "styled-components";

export const StyledTextAreaWrapper = styled.div`
  position: relative;

  ${({ theme }) => theme.media.onlyMobile`
    width: calc(100% - 30px);
    align-self: flex-end;
  `}

  > span:not(.error) {
    position: absolute;
    top: 6px;
    left: 8px;
    color: ${({ theme }) => theme.colors.neutralsTextLight};
    ${({ theme }) => theme.fontStyles.InterfaceCopy}
  }

  > div.counter {
    position: absolute;
    bottom: 21px;
    right: 8px;
    color: ${({ theme }) => theme.colors.neutralsTextLight};
    ${({ theme }) => theme.fontStyles.InterfaceCopy}

    > span {
      color: ${({ theme }) => theme.colors.primaryText};
      font-weight: 600;
    }
  }

  > div.input {
    width: 100%;
    height: 165px;
    border: none;
    border-bottom: 2px solid ${({ theme }) => theme.colors.primarySeparator};
    border-radius: 2px;
    padding: 6px 8px 36px 8px;
    box-sizing: border-box;
    color: ${({ theme }) => theme.colors.neutralsTextLight};
    background-color: ${({ theme }) => theme.colors.neutralsWhiteTint85};
    ${({ theme }) => theme.fontStyles.InterfaceCopy}

    &:hover {
      box-shadow:
        0px 8px 16px 0px rgba(161, 153, 194, 0.2),
        0px 4px 8px 0px rgba(161, 153, 194, 0.16),
        0px 2px 4px 0px rgba(161, 153, 194, 0.12),
        0px 1px 2px 0px rgba(161, 153, 194, 0.08);
      border-bottom: 2px solid ${({ theme }) => theme.colors.primaryTextHover};
    }

    > div {
      > div {
        padding: 0;
      }
    }

    > textarea {
      width: 100%;
      height: 100%;
      background: transparent;
      padding: 0;
      box-shadow: none;
      resize: none;
      border: none;
      box-sizing: border-box;
      margin-top: 4px;
      color: ${({ theme }) => theme.colors.neutralsTextLight};
      ${({ theme }) => theme.fontStyles.InterfaceCopy}

      &:focus {
        color: ${({ theme }) => theme.colors.neutralsText};
      }

      &:focus-visible {
        outline: none;
      }

      &::placeholder {
        color: ${({ theme }) => theme.colors.neutralsTextDisabled};
        ${({ theme }) => theme.fontStyles.InterfaceCopySmall}
        font-size: 14px;
        line-height: 20px;
      }
    }
    ${({ error }) =>
      error &&
      css`
        border-bottom: 2px solid ${({ theme }) => theme.colors.offTrackText} !important;
      `}
  }

  > span.error {
    display: block;
    height: 12px;
    ${({ theme }) => theme.fontStyles.InterfaceCopySmall}
    color: ${({ theme }) => theme.colors.offTrackText};
    padding-top: 4px;
  }
`;
